// source: external/config/config.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_common_pb = require('../../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
goog.exportSymbol('proto.configepb.GetReleaseItem', null, global);
goog.exportSymbol('proto.configepb.GetReleaseReq', null, global);
goog.exportSymbol('proto.configepb.GetReleaseResp', null, global);
goog.exportSymbol('proto.configepb.ItemCUReq', null, global);
goog.exportSymbol('proto.configepb.ItemDelReq', null, global);
goog.exportSymbol('proto.configepb.PublishReleaseReq', null, global);
goog.exportSymbol('proto.configepb.PublishReleaseResp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.configepb.GetReleaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.configepb.GetReleaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.configepb.GetReleaseReq.displayName = 'proto.configepb.GetReleaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.configepb.GetReleaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.configepb.GetReleaseResp.repeatedFields_, null);
};
goog.inherits(proto.configepb.GetReleaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.configepb.GetReleaseResp.displayName = 'proto.configepb.GetReleaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.configepb.GetReleaseItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.configepb.GetReleaseItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.configepb.GetReleaseItem.displayName = 'proto.configepb.GetReleaseItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.configepb.ItemCUReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.configepb.ItemCUReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.configepb.ItemCUReq.displayName = 'proto.configepb.ItemCUReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.configepb.ItemDelReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.configepb.ItemDelReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.configepb.ItemDelReq.displayName = 'proto.configepb.ItemDelReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.configepb.PublishReleaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.configepb.PublishReleaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.configepb.PublishReleaseReq.displayName = 'proto.configepb.PublishReleaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.configepb.PublishReleaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.configepb.PublishReleaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.configepb.PublishReleaseResp.displayName = 'proto.configepb.PublishReleaseResp';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.configepb.GetReleaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.configepb.GetReleaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.configepb.GetReleaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.GetReleaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemkey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    itemcomment: jspb.Message.getFieldWithDefault(msg, 4, ""),
    operator: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.configepb.GetReleaseReq}
 */
proto.configepb.GetReleaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.configepb.GetReleaseReq;
  return proto.configepb.GetReleaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.configepb.GetReleaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.configepb.GetReleaseReq}
 */
proto.configepb.GetReleaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemkey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemcomment(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.configepb.GetReleaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.configepb.GetReleaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.configepb.GetReleaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.GetReleaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemkey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getItemcomment();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.configepb.GetReleaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.configepb.GetReleaseReq} returns this
*/
proto.configepb.GetReleaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.configepb.GetReleaseReq} returns this
 */
proto.configepb.GetReleaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.configepb.GetReleaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.configepb.GetReleaseReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.configepb.GetReleaseReq} returns this
*/
proto.configepb.GetReleaseReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.configepb.GetReleaseReq} returns this
 */
proto.configepb.GetReleaseReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.configepb.GetReleaseReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string ItemKey = 3;
 * @return {string}
 */
proto.configepb.GetReleaseReq.prototype.getItemkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.GetReleaseReq} returns this
 */
proto.configepb.GetReleaseReq.prototype.setItemkey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ItemComment = 4;
 * @return {string}
 */
proto.configepb.GetReleaseReq.prototype.getItemcomment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.GetReleaseReq} returns this
 */
proto.configepb.GetReleaseReq.prototype.setItemcomment = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Operator = 5;
 * @return {string}
 */
proto.configepb.GetReleaseReq.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.GetReleaseReq} returns this
 */
proto.configepb.GetReleaseReq.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.configepb.GetReleaseResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.configepb.GetReleaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.configepb.GetReleaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.configepb.GetReleaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.GetReleaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.configepb.GetReleaseItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.configepb.GetReleaseResp}
 */
proto.configepb.GetReleaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.configepb.GetReleaseResp;
  return proto.configepb.GetReleaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.configepb.GetReleaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.configepb.GetReleaseResp}
 */
proto.configepb.GetReleaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.configepb.GetReleaseItem;
      reader.readMessage(value,proto.configepb.GetReleaseItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.configepb.GetReleaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.configepb.GetReleaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.configepb.GetReleaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.GetReleaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.configepb.GetReleaseItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.configepb.GetReleaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.configepb.GetReleaseResp} returns this
*/
proto.configepb.GetReleaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.configepb.GetReleaseResp} returns this
 */
proto.configepb.GetReleaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.configepb.GetReleaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.configepb.GetReleaseResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.configepb.GetReleaseResp} returns this
*/
proto.configepb.GetReleaseResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.configepb.GetReleaseResp} returns this
 */
proto.configepb.GetReleaseResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.configepb.GetReleaseResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated GetReleaseItem List = 3;
 * @return {!Array<!proto.configepb.GetReleaseItem>}
 */
proto.configepb.GetReleaseResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.configepb.GetReleaseItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.configepb.GetReleaseItem, 3));
};


/**
 * @param {!Array<!proto.configepb.GetReleaseItem>} value
 * @return {!proto.configepb.GetReleaseResp} returns this
*/
proto.configepb.GetReleaseResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.configepb.GetReleaseItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.configepb.GetReleaseItem}
 */
proto.configepb.GetReleaseResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.configepb.GetReleaseItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.configepb.GetReleaseResp} returns this
 */
proto.configepb.GetReleaseResp.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.configepb.GetReleaseItem.prototype.toObject = function(opt_includeInstance) {
  return proto.configepb.GetReleaseItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.configepb.GetReleaseItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.GetReleaseItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    key: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, ""),
    comment: jspb.Message.getFieldWithDefault(msg, 4, ""),
    operator: jspb.Message.getFieldWithDefault(msg, 5, ""),
    optime: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.configepb.GetReleaseItem}
 */
proto.configepb.GetReleaseItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.configepb.GetReleaseItem;
  return proto.configepb.GetReleaseItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.configepb.GetReleaseItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.configepb.GetReleaseItem}
 */
proto.configepb.GetReleaseItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.configepb.GetReleaseItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.configepb.GetReleaseItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.configepb.GetReleaseItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.GetReleaseItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOptime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.configepb.GetReleaseItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.configepb.GetReleaseItem} returns this
 */
proto.configepb.GetReleaseItem.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Key = 2;
 * @return {string}
 */
proto.configepb.GetReleaseItem.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.GetReleaseItem} returns this
 */
proto.configepb.GetReleaseItem.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Value = 3;
 * @return {string}
 */
proto.configepb.GetReleaseItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.GetReleaseItem} returns this
 */
proto.configepb.GetReleaseItem.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Comment = 4;
 * @return {string}
 */
proto.configepb.GetReleaseItem.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.GetReleaseItem} returns this
 */
proto.configepb.GetReleaseItem.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Operator = 5;
 * @return {string}
 */
proto.configepb.GetReleaseItem.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.GetReleaseItem} returns this
 */
proto.configepb.GetReleaseItem.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 OpTime = 6;
 * @return {number}
 */
proto.configepb.GetReleaseItem.prototype.getOptime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.configepb.GetReleaseItem} returns this
 */
proto.configepb.GetReleaseItem.prototype.setOptime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.configepb.ItemCUReq.prototype.toObject = function(opt_includeInstance) {
  return proto.configepb.ItemCUReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.configepb.ItemCUReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.ItemCUReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    operator: jspb.Message.getFieldWithDefault(msg, 2, ""),
    itemkey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    itemval: jspb.Message.getFieldWithDefault(msg, 4, ""),
    comment: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.configepb.ItemCUReq}
 */
proto.configepb.ItemCUReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.configepb.ItemCUReq;
  return proto.configepb.ItemCUReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.configepb.ItemCUReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.configepb.ItemCUReq}
 */
proto.configepb.ItemCUReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemkey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemval(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.configepb.ItemCUReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.configepb.ItemCUReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.configepb.ItemCUReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.ItemCUReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItemkey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getItemval();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.configepb.ItemCUReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.configepb.ItemCUReq} returns this
*/
proto.configepb.ItemCUReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.configepb.ItemCUReq} returns this
 */
proto.configepb.ItemCUReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.configepb.ItemCUReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Operator = 2;
 * @return {string}
 */
proto.configepb.ItemCUReq.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.ItemCUReq} returns this
 */
proto.configepb.ItemCUReq.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ItemKey = 3;
 * @return {string}
 */
proto.configepb.ItemCUReq.prototype.getItemkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.ItemCUReq} returns this
 */
proto.configepb.ItemCUReq.prototype.setItemkey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ItemVal = 4;
 * @return {string}
 */
proto.configepb.ItemCUReq.prototype.getItemval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.ItemCUReq} returns this
 */
proto.configepb.ItemCUReq.prototype.setItemval = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Comment = 5;
 * @return {string}
 */
proto.configepb.ItemCUReq.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.ItemCUReq} returns this
 */
proto.configepb.ItemCUReq.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.configepb.ItemDelReq.prototype.toObject = function(opt_includeInstance) {
  return proto.configepb.ItemDelReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.configepb.ItemDelReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.ItemDelReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    operator: jspb.Message.getFieldWithDefault(msg, 2, ""),
    itemkey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    itemval: jspb.Message.getFieldWithDefault(msg, 4, ""),
    comment: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.configepb.ItemDelReq}
 */
proto.configepb.ItemDelReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.configepb.ItemDelReq;
  return proto.configepb.ItemDelReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.configepb.ItemDelReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.configepb.ItemDelReq}
 */
proto.configepb.ItemDelReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemkey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemval(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.configepb.ItemDelReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.configepb.ItemDelReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.configepb.ItemDelReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.ItemDelReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItemkey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getItemval();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.configepb.ItemDelReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.configepb.ItemDelReq} returns this
*/
proto.configepb.ItemDelReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.configepb.ItemDelReq} returns this
 */
proto.configepb.ItemDelReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.configepb.ItemDelReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Operator = 2;
 * @return {string}
 */
proto.configepb.ItemDelReq.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.ItemDelReq} returns this
 */
proto.configepb.ItemDelReq.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ItemKey = 3;
 * @return {string}
 */
proto.configepb.ItemDelReq.prototype.getItemkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.ItemDelReq} returns this
 */
proto.configepb.ItemDelReq.prototype.setItemkey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ItemVal = 4;
 * @return {string}
 */
proto.configepb.ItemDelReq.prototype.getItemval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.ItemDelReq} returns this
 */
proto.configepb.ItemDelReq.prototype.setItemval = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Comment = 5;
 * @return {string}
 */
proto.configepb.ItemDelReq.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.ItemDelReq} returns this
 */
proto.configepb.ItemDelReq.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.configepb.PublishReleaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.configepb.PublishReleaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.configepb.PublishReleaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.PublishReleaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    operator: jspb.Message.getFieldWithDefault(msg, 4, ""),
    itemkey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    itemval: jspb.Message.getFieldWithDefault(msg, 6, ""),
    title: jspb.Message.getFieldWithDefault(msg, 7, ""),
    comment: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.configepb.PublishReleaseReq}
 */
proto.configepb.PublishReleaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.configepb.PublishReleaseReq;
  return proto.configepb.PublishReleaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.configepb.PublishReleaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.configepb.PublishReleaseReq}
 */
proto.configepb.PublishReleaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemkey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemval(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.configepb.PublishReleaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.configepb.PublishReleaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.configepb.PublishReleaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.PublishReleaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getItemkey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getItemval();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.configepb.PublishReleaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.configepb.PublishReleaseReq} returns this
*/
proto.configepb.PublishReleaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.configepb.PublishReleaseReq} returns this
 */
proto.configepb.PublishReleaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.configepb.PublishReleaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Operator = 4;
 * @return {string}
 */
proto.configepb.PublishReleaseReq.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.PublishReleaseReq} returns this
 */
proto.configepb.PublishReleaseReq.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ItemKey = 5;
 * @return {string}
 */
proto.configepb.PublishReleaseReq.prototype.getItemkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.PublishReleaseReq} returns this
 */
proto.configepb.PublishReleaseReq.prototype.setItemkey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string ItemVal = 6;
 * @return {string}
 */
proto.configepb.PublishReleaseReq.prototype.getItemval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.PublishReleaseReq} returns this
 */
proto.configepb.PublishReleaseReq.prototype.setItemval = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Title = 7;
 * @return {string}
 */
proto.configepb.PublishReleaseReq.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.PublishReleaseReq} returns this
 */
proto.configepb.PublishReleaseReq.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Comment = 8;
 * @return {string}
 */
proto.configepb.PublishReleaseReq.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.PublishReleaseReq} returns this
 */
proto.configepb.PublishReleaseReq.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.configepb.PublishReleaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.configepb.PublishReleaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.configepb.PublishReleaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.PublishReleaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    releasejson: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.configepb.PublishReleaseResp}
 */
proto.configepb.PublishReleaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.configepb.PublishReleaseResp;
  return proto.configepb.PublishReleaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.configepb.PublishReleaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.configepb.PublishReleaseResp}
 */
proto.configepb.PublishReleaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleasejson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.configepb.PublishReleaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.configepb.PublishReleaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.configepb.PublishReleaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.configepb.PublishReleaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getReleasejson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.configepb.PublishReleaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.configepb.PublishReleaseResp} returns this
*/
proto.configepb.PublishReleaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.configepb.PublishReleaseResp} returns this
 */
proto.configepb.PublishReleaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.configepb.PublishReleaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ReleaseJSON = 2;
 * @return {string}
 */
proto.configepb.PublishReleaseResp.prototype.getReleasejson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.configepb.PublishReleaseResp} returns this
 */
proto.configepb.PublishReleaseResp.prototype.setReleasejson = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


module.exports = proto.configepb;
